<main class="seo-page">
  <section class="seo-hero">
    <div class="seo-hero-copy">
      <p class="eyebrow">
        {{ page.eyebrow }}
        @if (localeLabel) {
          <span class="locale-tag"> / {{ localeLabel }}</span>
        }
      </p>
      <h1>{{ page.title }}</h1>
      <p class="seo-lede">{{ page.description }}</p>
      <div class="hero-actions">
        <button class="primary-button" type="button" (click)="startChat()">
          {{ copy().startChat }}
        </button>
        <a class="secondary-button" routerLink="/safety-tips">{{
          copy().safetyLink
        }}</a>
      </div>
      <div class="trust-row">
        <span>18+ only</span><span aria-hidden="true">&bull;</span
        ><span>No signup required</span><span aria-hidden="true">&bull;</span
        ><span>Free to start</span>
      </div>
    </div>
    <div class="seo-hero-panel" aria-label="{{ appName }} chat preview">
      <span class="panel-kicker">LIVE COMMUNITY</span>
      <strong>One good conversation can change your day.</strong>
      <div class="panel-line">
        <span class="avatar pink">M</span
        ><span><b>mellow_maya</b><small>just joined from India</small></span
        ><i aria-hidden="true">&bull;</i>
      </div>
      <div class="panel-line">
        <span class="avatar green">J</span
        ><span><b>jaywalks</b><small>talking about travel</small></span
        ><i aria-hidden="true">&bull;</i>
      </div>
      <span class="match-pill">* Random match</span>
    </div>
  </section>

  <section class="seo-page-body">
    <div class="seo-page-intro">
      <p class="eyebrow">{{ copy().explore }}</p>
      <h2>Meet someone outside your usual circle.</h2>
      <p>
        {{ appName }} gives you a low-pressure way to discover new perspectives.
        Choose a topic, say hello, and decide for yourself where the
        conversation goes.
      </p>
    </div>
    <div class="seo-section-grid">
      @for (section of page.sections; track section.title) {
        <article>
          <span class="section-number">0{{ $index + 1 }}</span>
          <h3>{{ section.title }}</h3>
          <p>{{ section.text }}</p>
        </article>
      }
      @if (page.sections.length === 0) {
        <article>
          <span class="section-number">01</span>
          <h3>Start with a simple hello</h3>
          <p>
            Guest access means you can get into a conversation quickly, without
            building a public profile first.
          </p>
        </article>
        <article>
          <span class="section-number">02</span>
          <h3>Find common ground</h3>
          <p>
            Interests give every match an opening topic, whether you want to
            talk about music, travel, games, or life.
          </p>
        </article>
        <article>
          <span class="section-number">03</span>
          <h3>Stay in control</h3>
          <p>
            Skip, block, and report tools are always close by. Leave any
            conversation that does not feel right.
          </p>
        </article>
      }
    </div>
  </section>

  <section class="seo-cta">
    <div>
      <p class="eyebrow">YOUR NEXT CONVERSATION</p>
      <h2>There is someone new to meet.</h2>
    </div>
    <button class="primary-button" type="button" (click)="startChat()">
      {{ copy().startChat }}
    </button>
  </section>
</main>
